export default __webpack_public_path__ + "static/media/DNo.9-3.dd25138d.jpg";